import { render, staticRenderFns } from "./EventApplyModal.vue?vue&type=template&id=527f13a4&scoped=true"
import script from "./EventApplyModal.vue?vue&type=script&lang=js"
export * from "./EventApplyModal.vue?vue&type=script&lang=js"
import style0 from "./EventApplyModal.vue?vue&type=style&index=0&id=527f13a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f13a4",
  null
  
)

export default component.exports